import * as React from 'react';
import { useTranslation } from 'react-i18next';

import InvoicesNotFound from '@/assets/invoices-not-found.svg';
import { MyInvoicesPageContainer } from '@/components/PrivateContainers/MyInvoicesPageContainer';
import { Recharges } from '@/types';

export type MyInvoicesPrivatePageProps = {
  invoices: Recharges[];
  loading: boolean;
};

export const MyInvoicesPrivatePage = ({ invoices, loading }: MyInvoicesPrivatePageProps) => {
  const { t } = useTranslation();

  const getNotRechargesFound = () => {
    return (
      <section className="h-auto lg:h-[520px] max-w-6xl m-auto px-3 py-2 lg:px-8 lg:py-10 text-center lg:text-left relative">
        <div className="z-40 relative h-full">
          <img src={InvoicesNotFound} alt="InvoicesNotFound" className="mb-8 m-auto" />
          <p className="text-xl text-center">{t('MyInvoicesPage.invoicesNotFound')}</p>
        </div>
      </section>
    );
  };

  return (
    <div className="flex justify-center  w-full mt-2 lg:mt-10 bg-md-lightGray">
      <div className="w-full bg-md-white mb-20">
        <h2 className="md__payments__title--h2">{t('BillingHistoryTable.title')}</h2>
        {invoices && invoices.length > 0 ? (
          <MyInvoicesPageContainer invoices={invoices} loading={loading} />
        ) : (
          getNotRechargesFound()
        )}
      </div>
    </div>
  );
};
